import React, { Component } from 'react';
import { Form, Row, Col, Card, Button, Modal } from 'react-bootstrap';
import { Redirect } from "react-router-dom";
import { Fetcher } from "../../../Helpers/fetcher.js";
import { Notify } from "../../../Helpers/notification.js";
import "./index.css";
import ApiBuilder from '../ApiBuilder.js';
import { convertArrayToString } from '../../../Helpers/utils.js';
import { CopyButton } from '../CopyButton.js';
import InstructionCard from '../Instruction.js';

class AddWebhooks extends Component {
    constructor(props) {
        super(props);
        const protocol = window.location.protocol;
        const slashes = protocol.concat("//");
        const sitePath = slashes.concat(window.location.hostname);

        this.state = {
            userId: props.app.userId,
            apiPath: props.app.apiPath,
            sitePath: sitePath,
            webhookAdded: false,
            webhookname: '',
            webhookurl: '',
            smsText: '',
            payload: '',
            headers: '',
            requestType: '',
            showConfirmModal: false,
            response: null,
            apiBuilderState: {
                url: '',
                method: 'GET',
                headers: [{ key: "", value: "" }],
                body: [{ key: "", value: "" }],
                headerMode: 'key-value',
                rawHeaders: ''
            }
        };
    }

    setvalue = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });

        if (name === "requestType") {
            this.handleMethod(value);
        }
    };

    handleUseUrl = (url) => {
        this.setState({ webhookurl: url });
    };

    handleMethod = (method) => this.setState(prev => ({
        requestType: method,
        apiBuilderState: { ...prev.apiBuilderState, method }
    }));

    handleResponse = (response) => {
        this.setState({ payload: response });
    };

    convertHeadersToString = (apiBuilderState) => {
        if (apiBuilderState.headerMode === 'key-value') {
            return convertArrayToString(apiBuilderState.headers);
        } else {
            return apiBuilderState.rawHeaders || '';
        }
    };

    handleApiBuilderChange = (apiBuilderState) => {
        const headersString = this.convertHeadersToString(apiBuilderState);
        this.setState({
            apiBuilderState,
            headers: headersString
        });
    };

    handleAddWebhooks = (event) => {
        event.preventDefault();

        if (!this.state.webhookname.trim()) {
            Notify.notify("Webhook Name is required");
            return;
        }
        if (!this.state.apiBuilderState.url) {
            Notify.notify("Please set a webhook URL");
            return;
        }

        this.setState({ showConfirmModal: true });
    };

    submitWebhook = () => {
        const data = {
            webhookName: this.state.webhookname,
            url: this.state.apiBuilderState.url,
            userId: Number(this.state.userId),
            smsText: this.state.requestType === 'GET' ? this.state.smsText : '',
            payload: this.state.requestType === 'POST' ? this.state.payload : '',
            requestType: this.state.requestType,
            header: this.state.headers
        };

        Fetcher.post(this.props.app.apiPath + '/api/obd/add/sms/webhooks', {
            headers: { "Content-type": "application/json" },
            method: 'POST',
            body: JSON.stringify(data)
        })
            .then(res => {
                if (res.message === 'Parameters Incorrect') {
                    Notify.notify(res.message);
                } else {
                    Notify.notify(res.message);
                    this.setState({ webhookAdded: true });
                }
            })
            .catch(err => {
                console.error('Error in Adding webhooks', err);
                Notify.notify('Error in Adding webhooks');
            });
    };

    confirmSubmission = () => {
        this.setState({ showConfirmModal: false });
        this.submitWebhook();
    };

    cancelSubmission = () => {
        this.setState({ showConfirmModal: false });
    };

    render() {
        if (this.state.webhookAdded) {
            return <Redirect to='/sms-webhook-list' />;
        }

        return (
            <>
                <div className="page-wrapper">
                    <Card className="page-card">
                        <Card.Header className="page-header">
                            Add SMS Webhook
                        </Card.Header>

                        <Card.Body>
                            <Row className="g-4">

                                {/* LEFT SIDE: FORM */}
                                <Col xs={12} md={7} className="left-panel">
                                    <Card className="section-card">
                                        <Card.Body>
                                            <Form onSubmit={this.handleAddWebhooks}>
                                                <Row>
                                                    <Col sm={6}>
                                                        <Form.Group className="form-group required">
                                                            <Form.Control
                                                                required
                                                                name="webhookname"
                                                                type="text"
                                                                placeholder="Webhook Name"
                                                                onChange={this.setvalue}
                                                                value={this.state.webhookname}
                                                                autoComplete="off"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={6}>
                                                        <Form.Group className="form-group required">
                                                            <Form.Select
                                                                required
                                                                name="requestType"
                                                                onChange={this.setvalue}
                                                                value={this.state.requestType}
                                                            >
                                                                <option value="">Select Request Type</option>
                                                                <option value="GET">GET</option>
                                                                <option value="POST">POST</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>

                                                {this.state.requestType && (
                                                    <Row className="mb-2">
                                                        <Col>
                                                            <ApiBuilder
                                                                initialUrl={this.state.apiBuilderState.url}
                                                                initialMethod={this.state.apiBuilderState.method}
                                                                initialHeaders={this.state.apiBuilderState.headers}
                                                                initialBody={this.state.apiBuilderState.body}
                                                                onUseUrl={this.handleUseUrl}
                                                                onMethod={this.handleMethod}
                                                                onResponse={this.handleResponse}
                                                                onStateChange={this.handleApiBuilderChange}
                                                            />
                                                        </Col>
                                                    </Row>
                                                )}

                                                <Row>
                                                    {this.state.requestType === "GET" &&
                                                        <Col>
                                                            <Form.Group className="form-group">
                                                                <Form.Label>Note: Please Paste the SMS text here</Form.Label>
                                                                <Form.Control
                                                                    required
                                                                    name="smsText"
                                                                    value={this.state.smsText}
                                                                    onChange={this.setvalue}
                                                                    as="textarea"
                                                                    rows="6"
                                                                />
                                                                <CopyButton text={this.state.smsText} />
                                                            </Form.Group>
                                                        </Col>
                                                    }

                                                    {this.state.requestType === "POST" &&
                                                        <Col>
                                                            <Form.Group className="form-group">
                                                                <Form.Label>Note: Payload here and replace the Mobile No. with {"{PHONE}"})</Form.Label>
                                                                <Form.Control
                                                                    required
                                                                    name="payload"
                                                                    value={this.state.payload}
                                                                    onChange={this.setvalue}
                                                                    as="textarea"
                                                                    rows="6"
                                                                />
                                                                <CopyButton text={this.state.payload} />
                                                            </Form.Group>
                                                        </Col>
                                                    }
                                                </Row>

                                                {this.state.headers &&
                                                    <Row>
                                                        <Col>
                                                            <Form.Group>
                                                                <Form.Label>Note: Headers (JSON format)</Form.Label>
                                                                <Form.Control
                                                                    name="headers"
                                                                    value={this.state.headers}
                                                                    disabled
                                                                    as="textarea"
                                                                    rows="5"
                                                                />
                                                                <CopyButton text={this.state.headers} />
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                }

                                                <Button variant="primary" className="mt-3" type="submit" disabled={!this.props.app.hasPermission('Manage Campaign.SMS Webhook List', 'add')}>
                                                    Add Sms Webhook
                                                </Button>
                                            </Form>
                                        </Card.Body>
                                    </Card>
                                </Col>

                                {/* RIGHT SIDE: INSTRUCTIONS */}
                                <Col xs={12} md={5} className="right-panel">
                                    <InstructionCard app={this.props.app} />
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </div>

                {/* Confirm Modal */}
                <Modal show={this.state.showConfirmModal} onHide={this.cancelSubmission}>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirm Submission</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Are you sure the response payload is correct?</Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.cancelSubmission}>No</Button>
                        <Button variant="primary" onClick={this.confirmSubmission}>Yes</Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default AddWebhooks;